export default __webpack_public_path__ + "static/media/p2.5a8a9a21.png";